import React from 'react'
import ClusterState from './ClusterState/ClusterState'

const ClusterContext = React.createContext<ClusterState | null>(null)

export default ClusterContext
